import React from 'react';
import { IEditorAnimPreviewManager } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/editor-state-animation/editor-anim-preview-manager.interface';
import type EditingStateManager from '@src/slide/application/service/editing-state-manager';
import { ICursorManager } from '@src/slide/application/service/cursor-manager/core/cursor-manager.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { ISnapLineService } from '@src/slide/application/service/snap-line-service/interface/snap-line-service.interface';


interface IServiceContext {
    editingStateManager?: EditingStateManager;
    cursorManager?: IDynamicService<ICursorManager>;
    editorAnimPreviewManager?: IEditorAnimPreviewManager;
    snapLineService?: ISnapLineService;
}

export const ServicesContext = React.createContext<IServiceContext>({});
ServicesContext.displayName = 'EditPanelServicesContext';
